module.exports = __webpack_public_path__ + "static/media/kotte-idle.d9e4a638.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/kotte-idle.png
// module id = 38
// module chunks = 0